import { render, staticRenderFns } from "./FreshReleases.vue?vue&type=template&id=fd8fdd9a&"
import script from "./FreshReleases.vue?vue&type=script&lang=js&"
export * from "./FreshReleases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports